import type { IDashboardTemplate } from "../types";
import { EFamilyTypes } from "../components/DashboardTemplatesTypes";
import { AssetsService } from "../../../../services/AssetsService";

const dashboard: IDashboardTemplate = {
    id: 2,
    title: "dashboard.templates.competitiveoverview.title",
    description: "dashboard.templates.competitiveoverview.description",
    descriptionLong: "dashboard.templates.competitiveoverview.description.long",
    keyMetrics: "dashboard.templates.competitiveoverview.keymetric",
    previewImage: AssetsService.assetUrl("/images/dashboard/templates/CompetitiveOverview-preview.png"),
    thumbnailImage: AssetsService.assetUrl("/images/dashboard/templates/CompetitiveOverview-thumb.png"),
    familyType: EFamilyTypes.Website,
    autoFillUserDomain: true,
    minItems: 2,
    maxItems: 5,
    widgets: [
        {
            pos: {
                sizeX: 3,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 0,
                col: 0,
            },
            properties: {
                multiple: true,
                multipleOverrides: {
                    pos: {
                        sizeX: 1,
                    },
                    properties: {
                        type: "PeriodOverPeriodVisits",
                        comparedDuration: "12m",
                        title: "Traffic Trend",
                        filters: {
                            timeGranularity: "Monthly",
                        },
                    },
                },
                metric: "EngagementVisits",
                webSource: "Total",
                duration: "1m",
                type: "Graph",
                filters: {
                    ShouldGetVerifiedData: true,
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Last Month's Daily Traffic",
                tooltip: "Last Month's Daily Traffic.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 1,
                maxSizeX: 2,
                row: 1,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "Total",
                duration: "12m",
                type: "PieChart",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                },
                width: "1",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Total Traffic Share",
                tooltip: "Mobile.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 1,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "Total",
                duration: "12m",
                type: "Graph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    timeGranularity: "Monthly",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Total Visits",
                tooltip: "Total Visits.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                minSizeX: 1,
                row: 2,
                col: 0,
                maxSizeY: 1,
                maxSizeX: 2,
            },
            properties: {
                flexibleDuration: true,
                mobileWebOnly: true,
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "Desktop",
                duration: "12m",
                type: "PieChart",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "1",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Desktop Traffic Share",
                tooltip: "Desktop.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 2,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                mobileWebOnly: true,
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "Desktop",
                duration: "12m",
                type: "Graph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    timeGranularity: "Monthly",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Desktop Visits",
                tooltip: "Desktop - Visits.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 1,
                maxSizeX: 2,
                row: 3,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                mobileWebOnly: true,
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "MobileWeb",
                duration: "12m",
                type: "PieChart",
                filters: {
                    ShouldGetVerifiedData: "true",
                    timeGranularity: "Monthly",
                    includeSubDomains: "true",
                },
                width: "1",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Mobile Traffic Share",
                tooltip: "Mobile.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                minSizeX: 2,
                row: 3,
                col: 2,
                maxSizeY: 2,
                maxSizeX: 4,
            },
            properties: {
                flexibleDuration: true,
                mobileWebOnly: true,
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "MobileWeb",
                duration: "12m",
                type: "Graph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    timeGranularity: "Monthly",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Mobile Visits",
                tooltip: "Mobile Visits.tooltip",
            },
        },
        {
            pos: {
                sizeX: 4,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 4,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: "EngagementOverview",
                webSource: "Desktop",
                duration: "12m",
                type: "EngagementTableDashboard",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Desktop Engagement",
                tooltip: "Engagement Metrics.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 4,
                minSizeX: 2,
                row: 5,
                col: 0,
                maxSizeY: 2,
                maxSizeX: 4,
            },
            properties: {
                flexibleDuration: true,
                mobileWebOnly: true,
                selectedChannel: "Direct",
                metric: "EngagementOverview",
                webSource: "MobileWeb",
                duration: "12m",
                type: "EngagementTableDashboard",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Mobile Engagement",
                tooltip: "Engagement Metrics.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 4,
                minSizeX: 2,
                row: 6,
                col: 0,
                maxSizeY: 2,
                maxSizeX: 4,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "TrafficSourcesOverview",
                webSource: "Desktop",
                duration: "1m",
                type: "BarChart",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Marketing Mix",
                tooltip: "Channels Overview.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 7,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "12m",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Direct",
                tooltip: "Traffic Share By Channel Direct.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 7,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Organic Search",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "12m",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Organic Search",
                tooltip: "SEO.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 8,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Paid Search",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "12m",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Paid Search",
                tooltip: "Paid Search.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 8,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Referrals",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "12m",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Referrals",
                tooltip: "Referrals.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 9,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Display Ads",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "12m",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Display Ads",
                tooltip: "Display Ads.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 9,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Social",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "12m",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Social",
                tooltip: "Social.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 10,
                col: 1,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Email",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "12m",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Email",
                tooltip: "Email.tooltip",
            },
        },
    ],
};
export default dashboard;
